<template>
  <div>
    <Head title="Create" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" :href="`/organizations/${orgType.id}`">
        {{ orgType.name }}
      </Link>
      <span class="text-indigo-400 font-medium"> / </span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Name" />
          <text-input
            v-if="orgType.id === 1"
            v-model="form.code"
            :error="form.errors.code"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Code" />
          <text-input
            v-model="form.email"
            :error="form.errors.email"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Email" />
          <text-input
            v-model="form.website"
            :error="form.errors.website"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Website" />
          <text-input
            v-model="form.phone"
            :error="form.errors.phone"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Phone" />
          <text-input
            v-model="form.address"
            :error="form.errors.address"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Address" />
          <text-input
            v-model="form.city"
            :error="form.errors.city"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="City" />
          <text-input
            v-model="form.region"
            :error="form.errors.region"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Province/State" />
          <select-input
            v-model="form.country"
            :error="form.errors.country"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Country">
            <option :value="null" />
            <option value="ID">
              Indonesia
            </option>
            <option value="CA">
              Canada
            </option>
            <option value="US">
              United States
            </option>
          </select-input>
          <text-input
            v-model="form.postal_code"
            :error="form.errors.postal_code"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Postal code" />
          <text-input
            v-if="orgType.id == 1"
            v-model="form.concern"
            :error="form.errors.concern"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Concern" />
          <textarea-input
            v-model="form.descriptions"
            :error="form.errors.descriptions"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Descriptions" />
          <text-input
            v-if="orgType.id == 2"
            v-model="form.npwp"
            :error="form.errors.npwp"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="NPWP" />
          <select-input
            v-if="orgType.id == 2"
            v-model="form.business_type"
            :error="form.errors.business_type"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Business Type">
            <option
              :value="null"
              selected
              disabled />
            <option value="PT">
              PT
            </option>
            <option value="CV">
              CV
            </option>
            <option value="UD">
              UD
            </option>
            <option value="Perorangan">
              Perorangan
            </option>
            <option value="Lainnya">
              Lainnya
            </option>
          </select-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Create {{ orgType.name }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
    },
    layout: Layout,
    props: {
        orgType: Object,
    },
    remember: 'form',
    data () {
        return {
            form: this.$inertia.form({
                name: null,
                code: null,
                email: null,
                website: null,
                phone: null,
                address: null,
                city: null,
                region: null,
                country: null,
                postal_code: null,
                organization_type_id: this.orgType.id,
                concern: null,
                descriptions: null,
                npwp: null,
                business_type: this.business(),
            }),
            linkorg: ' ',
        }
    },
    methods: {
        store () {
            this.form.post(`/organizations/${this.orgType.id}`)
        },
        business () {
            var business
            if (this.orgType.id == 1) business = 'Lainnya'
            return business
        },
    },
}
</script>
